import { apiClient } from './client'
import type {
  DeploymentSuggestionRequest,
  DeploymentSuggestionsResponse,
} from '../types/deploy'

const BASE_PATH = '/api/deploy'

export const deployApi = {
  getSuggestions: async (
    request: DeploymentSuggestionRequest
  ): Promise<DeploymentSuggestionsResponse> => {
    const response = await apiClient.post<DeploymentSuggestionsResponse>(
      `${BASE_PATH}/suggestions`,
      request
    )
    return response.data
  },
}
